import HowToRegIcon from '@mui/icons-material/HowToReg';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useGetBizneoParamsQuery } from 'src/shared/api/integrations/bizneo';
import { ShowError } from 'src/shared/components/ShowError';
import { ShowLoading } from 'src/shared/components/ShowLoading';
import { Step } from '../../components/Step';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Step4 } from './Step4';

type AfterConnectionProps = {
  isConnected?: boolean;
};

export const AfterConnection = ({ isConnected }: AfterConnectionProps) => {
  const { t } = useTranslation('settings');
  const {
    values: { subsidiary }
  } = useFormState();
  const { data, isLoading, isError, error } = useGetBizneoParamsQuery({ subsidiary }, { skip: !isConnected });

  if (isError) {
    const errorStatus = error && 'status' in error ? error.status : error;

    if (errorStatus === 403) {
      return (
        <ShowError
          error={undefined}
          additionalText={t('integrations.bizneo.error.the entered credentials have expired', {
            statusCode: errorStatus
          })}
        />
      );
    }

    return <ShowError error={error} />;
  }

  if (isLoading || !data) {
    return <ShowLoading />;
  }

  return (
    <>
      <Step2 companies={data.companies} />
      <Step3 absenceTypes={data.absenceTypes} />
      <Step4 customFields={data.customFields} />
      <Step
        title={`${t('integrations.step')} 5`}
        subtitle={t('integrations.factorial.review the data in the view edit employees section')}
        Icon={HowToRegIcon}
      />
    </>
  );
};
